import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import styles from "./PrefillSelector.module.css";
import { Tip } from "./Tip";

export const PREFILLS = ["FULL", "ESSENTIALS", "EMPTY"];

export const PrefillSelector = ({ selected, dirty, onChange }) => {
  const { t } = useTranslation();
  const TooltipAny: any = Tooltip;

  function onClick(prefill: string) {
    if (!dirty || confirm(t(`prefill_warning-confirm`))) {
      onChange(prefill);
    }
  }

  return (
    <FormControl fullWidth margin="normal">
      <FormLabel>{t("prefill_title")}</FormLabel>

      {dirty ? (
        <>
          <div className={styles.container}>
            <Button
              alert
              expanded
              size="small"
              onClick={() => {
                onClick("NONE");
              }}
            >
              {t(`prefill_reset`)}
            </Button>
          </div>
          <Tip>{t(`prefill_warning-existing`)}</Tip>
        </>
      ) : (
        <div className={styles.container}>
          <ToggleButtonGroup
            exclusive
            value={selected}
            onChange={(e, value) => onChange(value)}
            classes={{
              root: styles.group,
              grouped: styles.groupItem,
              firstButton: styles.roundButton,
              lastButton: styles.roundButton,
              middleButton: styles.roundButton,
            }}
            fullWidth
            sx={{
              "& .MuiToggleButtonGroup-firstButton": {
                borderRadius: "50%",
                width: "100px",
              },
              "& .MuiToggleButtonGroup-middleButton": {
                borderRadius: "50%",
                borderLeft: "1px solid var(--border-color)",
                width: "100px",
              },
              "& .MuiToggleButtonGroup-lastButton": {
                borderRadius: "50%",
                borderLeft: "1px solid var(--border-color)",
                width: "100px",
              },
              "& .MuiToggleButton-root": {
                padding: "0",
              },
            }}
          >
            {PREFILLS.map((prefill) => (
              <ToggleButton
                key={prefill}
                classes={{
                  root: styles.item,
                  selected: styles.itemSelected,
                }}
                value={prefill}
              >
                <TooltipAny
                  classes={{ tooltip: styles.tooltip }}
                  title={
                    <>
                      <div className={styles.tooltipTitle}>
                        {t(`prefill_title--${prefill.toLowerCase()}`)}
                      </div>
                      {t(`prefill_description--${prefill.toLowerCase()}`)}
                    </>
                  }
                >
                  <img
                    src={`/images/prefill-${prefill.toLowerCase()}.png`}
                    alt={prefill}
                  />
                </TooltipAny>
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
      )}
    </FormControl>
  );
};
